import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Button,
  DialogActions,
} from "@mui/material";
import CustomTypography from "../../../Components/Typography";
import { actionButtonStyle } from "../styles/styles";
import { useTranslation } from "react-i18next";

const DiscardChangesModal = (props) => {
  const { openDiscardChangesModal, setOpenDiscardChangesModal, handleDiscard } =
    props;

  const { t } = useTranslation("discard-changes-modal");

  const onClose = () => {
    setOpenDiscardChangesModal(false);
  };

  return (
    <Dialog
      open={openDiscardChangesModal}
      onClose={(_event, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") {
          return;
        }
        onClose();
      }}
      disableEscapeKeyDown
      sx={{
        "& .MuiPaper-root": {
          borderRadius: "12px",
        },
      }}
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        sx={{ px: "24px", py: "18px", borderBottom: "1px solid #EAEAEA" }}
      >
        <CustomTypography
          type="subheading"
          props={{
            color: "#2F2B3DE5",
            lineHeight: "28px",
          }}
        >
          {t("discard")}
        </CustomTypography>

        <IconButton onClick={onClose} sx={{ padding: "6px" }}>
          <img src="/cancel_icon.svg" alt="close" width={14} height={14} />
        </IconButton>
      </Box>

      <DialogContent sx={{ py: "32px", px: "24px" }}>
        <Box sx={{ maxWidth: "500px" }}>
          <CustomTypography
            type="subheading"
            props={{
              color: "#2F2B3DE5",
            }}
          >
            {t("close_without_save")}
          </CustomTypography>
        </Box>
      </DialogContent>

      <DialogActions
        sx={{
          py: "12px",
          px: "24px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            ...actionButtonStyle,
            background: "#808390",
            "&:hover": { backgroundColor: "#6E707C" },
          }}
        >
          {t("back_button")}
        </Button>

        <Button
          onClick={handleDiscard}
          variant="contained"
          sx={{
            ...actionButtonStyle,
          }}
        >
          {t("Ok_button")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DiscardChangesModal;
